WeekDayEditionController.$inject = ['$scope', '$rootScope', '$mdDialog', 'day', 'BusinessHoursFactory'];
export function WeekDayEditionController($scope, $rootScope, $mdDialog, day, BusinessHoursFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  
  init();

  function ok() {
    $mdDialog.hide({
      'id': $scope.dayId,
      'start': {
        'h': $scope.start.getHours(), 
        'm': $scope.start.getMinutes()
      },
      'end': {
        'h': $scope.end.getHours(), 
        'm': $scope.end.getMinutes()
      }
    });
  };

  function cancel() {
    $mdDialog.cancel();
  };
  
  function checkStartBeforeEndAndUpdateValidity() {
    const coherent = !$scope.start || !$scope.end || $scope.start <= $scope.end;
    $scope.weekDayForm.$setValidity('startBeforeEnd', coherent);
  };

  function init() {
    $scope.dayId = day.id;
    $scope.start = new Date(2016, 10, 3, day.start.h, day.start.m);
    $scope.end = new Date(2016, 10, 3, day.end.h, day.end.m);
    $scope.daysOfWeek = BusinessHoursFactory.daysOfWeek();

    var unsubscribeFn = $rootScope.$on('mdpTimePickerUpdated', checkStartBeforeEndAndUpdateValidity);
    $scope.$on('$destroy', unsubscribeFn);
  }
}
